import { useState, useEffect, useRef } from 'react'
import { reaction } from 'mobx'
import { FormField } from '@/Core/UI/Form'
import { FormContextProvider, createFormContext } from '@/Core/UI/Form/Providers'
import { FormFieldCellTemplate } from './NumberFormFieldCell'

export interface SimpleFormFieldCellProps {
    fieldName: string
    fieldDef: Record<string, any>
    initialValue: any
    onChange: (val: any) => void
}

export const SimpleFormFieldCell: React.FC<SimpleFormFieldCellProps> = ({ fieldName, fieldDef, initialValue, onChange }) => {
    const savedValue = useRef(initialValue)
    const [formStore] = useState(() =>
        createFormContext({
            fields: { [fieldName]: { ...fieldDef, isEditable: true } },
            initialValues: { [fieldName]: initialValue },
            isEditable: true,
        })
    )

    useEffect(() => {
        const dispose = reaction(
            () => formStore.getValue(fieldName),
            (val: any) => {
                if (val !== savedValue.current) {
                    savedValue.current = val
                    onChange(val)
                }
            }
        )
        return () => dispose()
    }, [formStore, fieldName, onChange])

    return (
        <FormContextProvider value={formStore}>
            <FormField name={fieldName} template={FormFieldCellTemplate} ignoreParentField={true} />
        </FormContextProvider>
    )
}
